/**
 * QuickChipsRow — replica app.jsx:228-232.
 *
 * Scroll horizontal sin scrollbar visible. Tap chip → onPick(chip)
 * → padre setea Composer value (concatena o reemplaza).
 *
 * Tap targets ≥44px.
 */
interface Props {
  chips: string[]
  onPick: (chip: string) => void
}

export function QuickChipsRow({ chips, onPick }: Props) {
  return (
    <div
      className="flex items-center gap-2 px-4 py-2 overflow-x-auto"
      style={{
        background: 'var(--color-bg-chat)',
        borderTop: '1px solid var(--color-border)',
        scrollbarWidth: 'none',
      }}
    >
      {chips.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => onPick(c)}
          className="text-[13px] whitespace-nowrap font-medium transition-all"
          style={{
            minHeight: 44,
            minWidth: 44,
            flexShrink: 0, // 21-oct: en la fila que se desliza no se aplastan (salían círculos superpuestos)
            padding: '8px 14px',
            borderRadius: 999,
            border: '1px solid var(--color-border)',
            background: 'var(--color-surface)',
            color: 'var(--color-text)',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-brand)'
            e.currentTarget.style.background = 'var(--color-brand-soft)'
            e.currentTarget.style.color = 'var(--color-brand-ink)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-border)'
            e.currentTarget.style.background = 'var(--color-surface)'
            e.currentTarget.style.color = 'var(--color-text)'
          }}
        >
          {c}
        </button>
      ))}
    </div>
  )
}
